import React from 'react';
import { RemoveButton } from './';

const TableRow = ({ from, to, date, guests, ticketClass, id }) => {
  return (
    <tr className="lws-bookedTable text-black" id={id}>
      <td className="px-6 py-4">
        <div className="flex items-center space-x-3">
          <p className="lws-bookedFrom">{from}</p>
        </div>
      </td>
      <td className="px-6 py-4">
        <p className="lws-bookedTo">{to}</p>
      </td>
      <td className="px-6 py-4 text-center">
        <p className="lws-bookedDate">{date}</p>
      </td>
      <td className="px-6 py-4 text-center">
        <p className="lws-bookedGustes">{guests}</p>
      </td>
      <td className="px-6 py-4 text-center">
        <span className="lws-bookedClass"> {ticketClass} </span>
      </td>
      <td className="px-6 py-4 text-center">
        <div className="flex justify-center gap-4">
          <RemoveButton id={id} />
        </div>
      </td>
    </tr>
  );
};

export default TableRow;
